import React, { useEffect, useState } from 'react';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import Avatar from '../assets/images/users/avt1.png'
import { BiSearchAlt, BiCalendar, BiLogIn } from "react-icons/bi";
import { useNavigate } from 'react-router-dom';
import { useParams } from "react-router-dom";
import {
    useMsal,
    MsalAuthenticationTemplate,
    useIsAuthenticated,
} from "@azure/msal-react";
import {
    InteractionType,
} from "@azure/msal-browser";
export default function MyTopbar(props: any) {
    const [keyword, setKeyword] = useState("");
    const { inProgress, instance, accounts } = useMsal();
    const isAuthenticated = useIsAuthenticated();
    const navigate = useNavigate();

    const hendelChange = (e: any) => {
        const { value, name } = e.target
        setKeyword(value)
    }
    const hendleEnter = (e: any) => {
        if (e.keyCode === 13) {
            onSearch()
        }
    }
    const onSearch = () => {

        props.triggerSearch(keyword);
    }

    const handleLogout = () => {
        instance.logoutRedirect({
            postLogoutRedirectUri: "/hrevent/myevents", // The URI to redirect to after logout
        });
    };
    return (
        <>
            <MsalAuthenticationTemplate interactionType={InteractionType.Redirect}>
                <Navbar bg="white" data-bs-theme="light" className='px-2 ' sticky="top">
                    <div className='container-fluid'>
                      {props.isAdmin ? 
                        <Navbar.Brand onClick={() => navigate('/admin')} style={{cursor:"pointer"}}>C&S Events</Navbar.Brand>
                        :
                        <Navbar.Brand onClick={() => navigate('/')} style={{cursor:"pointer"}}>C&S Events</Navbar.Brand>
                        }
                        <Nav className="me-auto top-menu ms-4">
                            <Nav.Link onClick={() => navigate('/myevents')} className='active'><BiCalendar size={20} />My Events</Nav.Link>
                            {/* <Nav.Link  href="#report"><BiBarChartAlt2 size={20} /> Report</Nav.Link> */}
                        </Nav>
                        <Nav>
                          
                            <div className='border-end pe-3 search-bar'>
                                <div className="input-group">
                                    <input type="text" className="form-control" aria-describedby="basic-addon2" onChange={(e: any) => hendelChange(e)} onKeyDown={(e: any) => hendleEnter(e)} value={keyword} />
                                    <span className="input-group-text" id="basic-addon2" onClick={() => onSearch()}><BiSearchAlt /></span>
                                </div>
                            </div>
                            <img src={(props.photoData === "") ? Avatar : props.photoData} className='admin-img border ms-3' alt="User Avatar" />
                            <div className='user-profile me-1 px-3'>
                                <label>{accounts[0]?.name}</label>
                                <p>
                                    <a className='text-gray' href={`${window.location.origin}/myevents`}>My Events</a>
                                </p>

                            </div>
                            {props.isAdmin ? 
                                <div className="add-event ps-3 border-start border-end me-1 px-3 ">
                                    <a className="btn admin-event-btn" href="/admin">
                                        <span>Admin Event</span>
                                    </a>
                                </div>
                            : null}
                            <div>
                                <BiLogIn className='logOut' onClick={() => handleLogout()} />
                            </div>
                        </Nav>
                    </div>
                </Navbar>
            </MsalAuthenticationTemplate>
        </>
    )
}
